<template>
  <div @click="selectEnvironment()"  class="environment-card" :class="{'big-environment-card':withPicture}">
    <sheet-block-overview-picture v-if="withPicture" :picture-datas="datas.thumbnail" :hide-download="true" />
    <h3 class="title">{{ datas.name? datas.name : 'n.a' }}</h3>
    <span class="bottom-icon icon-arrow-right" :class="brandColor"></span>
  </div>
</template>

<script>
import SheetBlockOverviewPicture from "@/components/SheetBlock/SheetBlockOverviewPicture";
export default {
  name: 'EnvironnementCard',
  components: {
    SheetBlockOverviewPicture,
  },
  props: {
    datas: {
      type: Object
    },
    saveRoute: {
      type: Boolean,
      default: true
    },
    withPicture : {
      type: Boolean,
      default:false
    }
  },

  methods: {
    selectEnvironment() {
      this.$store.commit('qualifyIndustry/setEnvironment',this.datas.slug);
      this.$store.commit('qualifyIndustry/setCurrentContext', this.datas.id);
      this.$router.push({ path: '/qualify-industry/building-and-shelving?init=1' });

    },
    environmentPicture(environment) {
      try {
        return require(`@/assets/img/markets/${environment.code}.jpg`)
      } catch (e) {
        return null
      }
    },
  }
}
</script>

<style lang="scss">
.environment-card {
  position: relative;
  //height: 270px;
  width: 185px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 30px;
  text-align: center;
  border-radius: 20px;
  box-shadow: 20px 20px 74px 0 rgba(0, 0, 0, 0.15);
  background-color: $white;
  border: solid 2px $white;
  transition: border-color 0.3s ease;

  &.big-environment-card {
    height:auto;
    padding-top:20px;
    padding-bottom:20px;
  }

  @media print {
    display: block;
    height: auto;
    width: auto;
    box-shadow: none;
    text-align: left;
    padding: 0;
    border: 0;
  }

  @each $brand in $brands {
    .brand-#{$brand} & {
      &:hover {
        border: solid 2px brand-color($brand);
      }
    }
  }

  .title {
    @include small-title($black);
    line-height: 20px;
    margin: 5px 0;
  }

  .bottom-icon {
    // margin-top: 20px;
    font-size: 26px;

    @media print {
      display: none;
    }
  }
}
</style>
